require('../style-guide-extends/libs/bootstrap-chosen/bootstrap-chosen.css');
require('../style-guide-extends/css/extend_bootstrap-chosen.css');
require('../style-guide-extends/libs/bootstrap-chosen/chosen.jquery.min.js');

require('../style-guide-extends/css/extend_bootstrap.css');
require('../style-guide-extends/css/auth.css');
require('../style-guide-extends/css/onboard.css');

// For translator dashbaord metrics
window.Raphael = require('../gengo/js/plugins/raphael.2.2.0.min.js');

require('../style-guide-extends/css/translator-dashboard/index.scss');
require('../style-guide-extends/js/translator-dashboard/index.js');



// WEBPACK FOOTER //
// ./entries/style-guide-extends.js